module.exports = __webpack_public_path__ + "img/areaBlueOrder.93025036.png";